import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import { FormGroup, InputGroupAddon, InputGroupText, InputGroup } from 'reactstrap';
import { Field, useFormikContext } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fontAwesome from '@fortawesome/free-solid-svg-icons';

const EmailField = props => {
  const [focusedField, setFocusedField] = useState(false)
  const { isSubmitting } = useFormikContext();
  
    
    return (
      <FormGroup
        className={classnames({
          "mb-3": !props.removeMb3,
          focused: focusedField,
        })}
      >
        <InputGroup className="input-group-merge input-group-alternative">
          <InputGroupAddon addonType="prepend">
            <InputGroupText>
              {
                props.fontAwesome ?
                  <FontAwesomeIcon icon={ fontAwesome[props.fontAwesome] } /> :
                  <i className={ props.icon }/>
              }
            </InputGroupText>
          </InputGroupAddon>
          <FormattedMessage id="fields.email">
            {
              placeholder =>
                <Field
                  name="email"
                  type="email"
                  className="form-control"
                  placeholder={ `${placeholder}` + (props.required === true ? ' *' : '')}
                  onFocus={
                    () => {
                      setFocusedField(true)
                    }
                  }
                  onBlur={
                    e => {
                      props.handleBlur(e)
                      setFocusedField(false)
                    }
                  }
                  disabled={isSubmitting}
                />
            }
          </FormattedMessage>
        </InputGroup>
      </FormGroup>
    );
  }


EmailField.defaultProps = {
  fontAwesome: '',
  icon: 'ni ni-email-83',
  removeMb3: false,
}
export { EmailField };
